import React from 'react';
import './App.css';
import { ColorModeContext, useMode } from "./theme.js";
import { CssBaseline, ThemeProvider } from "@mui/material";
import SnackBarContextProvider from './Context/SnackBarContextProvider.jsx';
import SnackbarAlert from './SystemDesign/SnackbarAlert.jsx';
import AppRoutes from './Auth/AppRoutes.jsx';
import { Provider } from 'react-redux';
import { store } from "./store/store";
import { AuthContextProvider } from './Context/AuthContext.jsx';
import NotificationsContextProvider from "./Context/NotificationsContexteProvider.jsx";

// Memoize at module scope to avoid creating new component identities on each App render
const MemoizedSnackbarAlert = React.memo(SnackbarAlert);
const MemoizedAppRoutes = React.memo(AppRoutes);


function App() {
  const [theme, colorMode] = useMode();
  return (
    <Provider store={store}>
      <NotificationsContextProvider>
        <SnackBarContextProvider>
          <AuthContextProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div>
                  <MemoizedSnackbarAlert key="AppSnackBarAlert" />
                  <MemoizedAppRoutes />
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
          </AuthContextProvider>
        </SnackBarContextProvider>
        </NotificationsContextProvider>
    </Provider>
  );
}

export default App;
